export class GenericTreeType {
    id: number;
    name: string;
    sifra: string;
    parentId: number;
    suzeniTipId: number;
    nadredjenoSuzenoSvojstvoId: number;
    jePodatak: boolean;
    statusNaTipuId: number;
    statusNaPojmuId: number;
    statusId: number;
    idZaCuvanje: number;
    jeDozvoljenVisestrukiIzbor: boolean;
    podredjene: GenericTreeType[];
    isDisabled: boolean;
    redniBroj: number | null;
    isChecked: boolean = false;
    putanja: string;
    putanjaNadredjenog: string;
    pojamUSastavuVrstaTipaId: number | null;
    highlighted: boolean = false;

    constructor(id: number, naziv: string, sifra: string, parentId: number, suzeniTipId: number, nadredjenoSuzenoSvojstvoId: number, jePodatak: boolean, statusNaTipuId: number, statusNaPojmuId: number, statusId: number, jeDozvoljenVisestrukiIzbor: boolean, idZaCuvanje: number, isDisabled: boolean, redniBroj: number | null, isChecked: boolean = false) {
        this.id = id;
        this.name = naziv;
        this.sifra = sifra;
        this.parentId = parentId;
        this.suzeniTipId = suzeniTipId;
        this.nadredjenoSuzenoSvojstvoId = nadredjenoSuzenoSvojstvoId;
        this.jePodatak = jePodatak;
        this.statusNaTipuId = statusNaTipuId;
        this.statusNaPojmuId = statusNaPojmuId;
        this.statusId = statusId;
        this.jeDozvoljenVisestrukiIzbor = jeDozvoljenVisestrukiIzbor;
        this.idZaCuvanje = idZaCuvanje;
        this.isDisabled = isDisabled;
        this.redniBroj = redniBroj;
        this.isChecked = isChecked;
    }
}

export interface Node {
    expandable: boolean;
    name: string;
    level: number;
    parentId: number;
    id: number;
    sifra: string;
    jePodatak: boolean;
    putanja: string;
}

export interface LazyTreeNode {
    id: number;
    putanja: string;
    putanjaNadredjenog: string;
    pojamuSastavuId?: number;
    vrstaTipaId: number;
    name: string;
    level?: number;
    expandable?: boolean;
    crossed?: boolean; //ako je neaktivno precrtati
    children?: LazyTreeNode[];
}